(function () {
  'use strict';

  angular.module('eclipseApp.cfa').factory('cfaService', ['util', function (util) {
    var service = {};

    service.getCFAData = function () {
      var overrideLangProvPref = {
        language: 'en',
        province: 'on',
        samKey: 'default',
        getUserPref: false
      };

      // if the language is valid...
      if (util.isValidLanguage(util.getParameterByName('language').toLowerCase())) {
        overrideLangProvPref.language = util.getParameterByName('language').toLowerCase();
      }

      // ... and if the province is valid...
      if (util.isValidProvince(util.getParameterByName('province').toLowerCase())) {
        overrideLangProvPref.province = util.getParameterByName('province').toLowerCase();
      }

      // ... set rui to those valid values and reload the app with the config
      return overrideLangProvPref;
    };

    return service;
  }]);
})();
